<template>
  <div v-if="isVisibility">
    <el-drawer :visible.sync="isVisibility" direction="rtl" :before-close="handleClose"
      :size="isFull || $route.path.includes('detail') ? '100%' : '80%'" :with-header="false" destroy-on-close>
      <div style="
          width: 100%;
          height: 100%;
          overflow: hidden;
          display: flex;
          flex-direction: column;
        ">
        <div class="drawerHeader">
          <div class="between">
            <div v-if="pageNameList.length === 1" class="center">
              <span class="title">{{
                viewPage.type === "copy"
                  ? viewPage.val.formName
                  : viewPage.formName
              }}</span>
              <span v-if="fieldData && fieldData.Status && type !== 'copy'" style="
                  display: inline-block;
                  font-size: 12px;
                  margin-left: 20px;
                  color: #fff;
                  border-radius: 10px;
                  height: 20px;
                  line-height: 20px;
                  padding: 0 12px;
                " :style="{ background: statusColor[fieldData.Status] }">{{ statusName[fieldData.Status] }}</span>
            </div>
            <div v-else class="center">
              <el-breadcrumb separator="/">
                <el-breadcrumb-item style="cursor: pointer" @click.native="handleBreadcrumb(item, index)"
                  v-for="(item, index) in pageNameList" :key="index">
                  <span class="title">
                    {{ item.formName }}
                  </span>
                </el-breadcrumb-item>
              </el-breadcrumb>
              <span v-if="
                fieldData &&
                fieldData.Status &&
                type !== 'add' &&
                type !== 'copy'
              " style="
                  font-size: 12px;
                  margin-left: 10px;
                  color: #fff;
                  border-radius: 4px;
                  padding: 2px 6px;
                " :style="{ background: statusColor[fieldData.Status] }">{{ statusName[fieldData.Status] }}</span>
            </div>

            <div class="center">
              <div @click="handleEdit" class="center copyBtn" style="margin-right: 20px" v-if="
                type === 'see' &&
                btnPermission.includes('SUBMIT') &&
                fieldData &&
                fieldData.Status === 'Effective' &&
                activeTabItems &&
                activeTabItems.id === fieldData.formId
              ">
                <svg-icon icon-class="icon_edit" style="margin-right: 3px"></svg-icon>
                <span>编辑</span>
              </div>
              <div style="margin-left: auto; gap: 20px" class="flex" v-if="type !== 'add' && type !== 'copy'">
                <div @click="handleCopy" class="center copyBtn">
                  <svg-icon icon-class="icon_copy" style="margin-right: 3px"></svg-icon>
                  <span>复制</span>
                </div>

                <div v-if="btnPermission.includes('PRINT')" @click="handlePrint" class="center copyBtn">
                  <svg-icon icon-class="icon_print" style="margin-right: 3px"></svg-icon>
                  <span>打印</span>
                </div>
              </div>
              <el-tooltip effect="dark" :content="isFull ? '非全屏' : '全屏'" placement="bottom">
                <svg-icon icon-class="icon_full" @click="isFull = !isFull" v-if="!isFull"
                  style="margin-left: 20px; cursor: pointer"></svg-icon>
                <svg-icon v-else icon-class="icon_noFull" @click="isFull = !isFull"
                  style="margin-left: 20px; cursor: pointer"></svg-icon>
              </el-tooltip>

              <div style="
                  width: 1px;
                  height: 24px;
                  background: #f5f5f5;
                  margin: 0 22px;
                "></div>
              <i class="el-icon-close" style="color: #8893a7; font-size: 16px; cursor: pointer"
                @click="handleClose"></i>
            </div>
          </div>
        </div>
        <div class="drawerPage">
          <div style="
              display: flex;
              flex-direction: column;
              width: 100%;
              flex: 1;
              overflow: hidden;
            ">
            <div v-if="type !== 'add' && type !== 'copy'" style="
                width: 100%;
                height: 52px;
                border-bottom: 5px solid #f5f7fa;
              ">
              <ul class="tabs">
                <li class="tabsItems" v-for="item in relevanceList" :key="item.id" :class="{
                  activeTabItems:
                    activeTabItems && activeTabItems.id === item.id,
                }" @click="handleTab(item)">
                  {{ item.formName }}
                  <span>
                    {{
                      item.count || item.count === 0
                        ? `(${item.count})`
                        : item.count
                    }}
                  </span>
                </li>
              </ul>
            </div>
            <div class="content">
              <img src="https://static.h3yun.com/common-resource/pc/form-detail/images/shenpitongguo.svg" alt=""
                style="position: absolute;top: 50px;right: 10px;z-index: 10;pointer-events: none;" v-if="fieldData &&
                  fieldData.Status && fieldData.Status === 'Effective'">
              <el-form :model="formData" label-position="top" v-if="
                activeTabItems.id === fieldData.formId ||
                type === 'add' ||
                type === 'copy'
              " v-loading="formLoading" ref="ruleForm">
                <el-row>
                  <el-col v-for="(item, index) in field" :key="item.code + index" :span="item.parentId ? 12 : 24"
                    v-show="!item.showTable">
                    <el-form-item v-if="
                      item.itemLimit &&
                      item.itemLimit.isShow &&
                      !item.isHide &&
                      item.formId
                    " :label="item.name === 'TableList' || item.name === 'Description'
                      ? ''
                      : item.title
                      " label-width="100px" style="margin: 10px 20px" :rules="[
                        {
                          required: item.itemLimit.isRequire,
                          message: '请输入',
                          trigger: ['blur', 'change'],
                        },
                      ]" :prop="item.code">
                      <component :is="item.name" :item="item" :formData="formData" @queryList="queryList"
                        :field.sync="field" :type="type">
                      </component>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
              <div style="display: flex; width: 100%; height: 100%" v-else>
                <div style="
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    overflow: hidden;
                    padding: 16px 20px;
                  ">
                  <div class="between">
                    <el-button type="text" size="small" icon="el-icon-plus" @click="handleTableAdd">新增数据</el-button>
                    <div style="cursor: pointer; padding: 0" class="table-filter" @click="isCollapse = !isCollapse"
                      v-if="!isCollapse">
                      <svg-icon icon-class="icon_filter"></svg-icon>
                      <span class="filter-title">筛选条件</span>
                    </div>
                  </div>
                  <el-table style="margin-top: 10px; flex: 1" v-loading="tableLoading" stripe
                    :data="relevanceDetails.data.records" border height="100%" :header-cell-style="headerCellStyle"
                    :cell-style="cellStyle">
                    <el-table-column type="index" width="60" align="center" label="序号">
                    </el-table-column>
                    <el-table-column prop="Name" label="数据标题" align="center" width="250" show-overflow-tooltip>
                      <template #default="{ row }">
                        <div @click="handleName(row)">
                          <span href="#" class="caption" style="color: #107fff">
                            {{ row.Name || "\\" }}
                          </span>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column :label="column.title" :prop="column.code" v-for="column in relevanceDetails.field"
                      :key="column.code" show-overflow-tooltip align="center" :width="['Created', 'Updated', 'DateTime'].includes(column.code)
                        ? '180px'
                        : flexColumnWidth(
                          column.title,
                          relevanceDetails.data.records,
                          column.code
                        )
                        "></el-table-column>
                  </el-table>
                  <div style="
                      display: flex;
                      justify-content: flex-end;
                      margin-top: 6px;
                    ">
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                      :page-sizes="[10, 20, 50, 100]" :page-size="10" layout="total, sizes, prev, pager, next"
                      :total="total">
                    </el-pagination>
                  </div>
                </div>

                <div style="
                    width: 280px;
                    border-left: 5px solid #f5f7fa;
                    display: flex;
                    flex-direction: column;
                  " v-show="isCollapse">
                  <div class="between" style="border-bottom: 5px solid #f5f7fa">
                    <div style="cursor: pointer" class="table-filter">
                      <svg-icon icon-class="icon_filter"></svg-icon>
                      <span class="filter-title">筛选条件</span>
                    </div>
                    <span class="collapse-search" @click="isCollapse = !isCollapse">收起</span>
                  </div>
                  <div style="overflow: auto; height: 100%; overflow-x: hidden">
                    <el-form v-if="relevanceDetails.search" :model="tableFormData" :inline="true" label-position="top"
                      class="formData">
                      <el-form-item v-for="item in relevanceDetails.search" :key="item.code" :label="item.title"
                        label-width="100px" style="
                          margin-left: 20px;
                          width: calc(100% + 60px);
                          margin-bottom: 10px;
                        ">
                        <component :is="item.name" :item="item" :formData="tableFormData" @queryList="tableQueryList">
                        </component>
                      </el-form-item>
                    </el-form>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- -----------------------------侧边栏---------------------------- -->
          <div class="process" :style="{ width: open ? '428px' : '83px' }" v-if="
            type !== 'add' &&
            type !== 'copy' &&
            activeTabItems.formName === '详情'
          ">
            <el-tabs v-model="activeName" @tab-click="handleClick" v-if="open">
              <el-tab-pane label="流程日志" name="flowLog">
                <flowLog :flowLogList="flowLogList" v-if="flowLogList && flowLogList.length > 0"
                  @handleUrge="handleUrge">
                </flowLog>
                <el-empty description="暂无数据" v-else></el-empty>
              </el-tab-pane>
              <el-tab-pane :label="`评论(${commentList && commentList.length})`" name="comment">
                <comment :commentList.sync="commentList"></comment>
              </el-tab-pane>
              <el-tab-pane label="操作日志" name="operateLog">
                <operateLog v-if="operateLogList && operateLogList.length > 0" :operateLogList="operateLogList"
                  style="padding-bottom: 60px"></operateLog>
                <el-empty description="暂无数据" v-else></el-empty>
              </el-tab-pane>
            </el-tabs>
            <div v-else>
              <div v-for="item in sidebarIcon" :key="item.id" class="tickets" @click="handleOriginal(item.id)">
                <div>
                  <img :src="item.icon" alt="" style="width: 16px; height: 16px" />
                </div>
                <span>{{ item.name }}</span>
              </div>
            </div>
            <div v-show="open">
              <div :class="`arrow-${open ? 'right' : 'left'}`" :style="{ right: open ? '428px' : '83px' }"
                @click="handleOpen">
                <div v-if="open" class="left"></div>
                <div v-else class="right"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="confirmBtn" v-if="shouldShowConfirmBtn">
          <el-button type="success" v-if="isShow" @click="
            taskApproveDialog = true;
          $set(form, 'comment', '同意');
          status = 1;
          " size="small">同意</el-button>
          <el-button style="background: #f2f3f5" v-if="isShow" @click="
            taskApproveDialog = true;
          $set(form, 'comment', '拒绝');
          status = 2;
          " size="small">拒绝</el-button>
          <el-button type="primary" v-if="isShow" @click="
            taskApproveDialog = true;
          $set(form, 'comment', '');
          status = 3;
          " size="small">转交</el-button>
          <el-button type="primary" @click="handleDel" v-if="
            type === 'edit' &&
            btnPermission.includes('DELETE') &&
            fieldData &&
            activeTabItems &&
            activeTabItems.id === fieldData.formId
          " size="small">删除</el-button>
          <el-button type="primary" @click="confirmInfo" v-if="
            type === 'add' ||
            type === 'copy' ||
            (type !== 'see' &&
              btnPermission.includes('SUBMIT') &&
              fieldData &&
              activeTabItems &&
              activeTabItems.id === fieldData.formId)
          " size="small">保存</el-button>
        </div>
      </div>
    </el-drawer>
    <el-dialog title="审批" :visible.sync="taskApproveDialog" width="600px" @close="form = {}"
      :close-on-click-modal="false">
      <el-form ref="form" :model="form" label-width="90px">
        <el-form-item :label="`${status === 2 ? '*' : ''}输入意见：`">
          <el-input v-model="form.comment" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="*转交人员：" v-if="status == 3">
          <component :is="'UserPicker'" :formData="form" :item="{ code: 'deliverId' }"></component>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="taskApproveDialog = false">取 消</el-button>
        <el-button type="primary" @click="confirmInfo('Approve')">确 定</el-button>
      </span>
    </el-dialog>
    <printPage :showPrintPage.sync="showPrintPage" :field="field" :formOptionInfo="fieldData"
      :pageNameList="pageNameList" :logList="logList" :fieldData="fieldData"></printPage>
  </div>
</template>

<script>
import { pageListAdd, pageListDel } from "@/api/drawerPage";
import { getPageViewList, getoperateLogDetail } from "@/api/process";
import { taskApprove, getProcessDetail, urgeFlow } from "@/api/setProcess";
import components from "@/views/home/CompExport";
import flowLog from "./flowLog";
import operateLog from "./operateLog";
import comment from "./comment";
import printPage from "./printPage";
import {
  flexColumnWidth,
  headerCellStyle,
  cellStyle,
  convertDynamicLogic,
} from "@/utils/CustomUtil.js";
import * as acorn from "acorn";

import { getCommentList } from "@/api/design";
export default {
  name: "drawerPage",
  components: { ...components, flowLog, operateLog, printPage, comment },
  computed: {
    // 详情加载
    formLoading: {
      get() {
        return this.$store.state.formData.formLoading;
      },
      set(val) {
        this.$store.commit("formData/setFormLoading", val);
      },
    },
    // 详情页面控制
    isVisibility: {
      get() {
        return this.$store.state.formData.isVisibility;
      },
      set(val) {
        this.$store.commit("formData/setIsVisibility", val);
      },
    },
    // 详情页面数据
    formData() {
      return this.$store.state.formData.formData;
    },
    // 详情页面组件
    field() {
      return this.$store.state.formData.field;
    },
    //
    fieldData() {
      return this.$store.state.formData.fieldData;
    },
    // 详情页面按钮
    btnPermission() {
      return this.$store.state.formData.btnPermission;
    },
    // 详情页面状态
    type: {
      get() {
        return this.$store.state.formData.drawerPageType;
      },
      set(val) {
        this.$store.commit("formData/setDrawerPageType", val);
      },
    },
    // 流程按钮
    isShow() {
      let user = this.$store.getters.userInfo;
      if (
        this.approve?.approveUsers?.includes(user.id) &&
        this.type !== "copy" &&
        this.activeTabItems &&
        this.activeTabItems.id === (this.viewPage && this.viewPage.formId)
      ) {
        return true;
      } else return false;
    },
    // 最后路由栈-当前页面
    viewPage() {
      return this.$store.getters.viewPage;
    },
    // 路由栈
    pageNameList() {
      return this.$store.state.formData.pageNameList;
    },
    // 流程
    approve() {
      return this.$store.state.formData.approve;
    },
    // 关联激活
    activeTabItems: {
      get() {
        return this.$store.state.formData.activeTabItems;
      },
      set(val) {
        this.$store.commit("formData/setActiveTabItems", val);
      },
    },
    // 关联列表
    relevanceList() {
      return this.$store.state.formData.relevanceList;
    },
    shouldShowConfirmBtn() {
      return (
        this.isShow ||
        (this.type === "edit" &&
          this.btnPermission.includes("DELETE") &&
          this.fieldData &&
          this.activeTabItems &&
          this.activeTabItems.id === this.fieldData.formId) ||
        this.type === "add" ||
        this.type === "copy" ||
        (this.type !== "see" &&
          this.btnPermission.includes("SUBMIT") &&
          this.fieldData &&
          this.activeTabItems &&
          this.activeTabItems.id === this.fieldData.formId)
      );
    },
  },
  watch: {
    // 设置组件是否隐藏
    formData: {
      handler(val) {
        this.field.forEach((item) => {
          if (item.hideValue) {
            let obj = JSON.parse(item.hideValue) || {};
            // CONTAINS(val.F0000002,'是'）
            //有CONTAINS函数，则执行函数，否则直接返回
            let str = convertDynamicLogic(obj.hiddenVal);
            console.log(str);
            this.$set(item, "isHide", eval(str));
          }
        });
      },
      deep: true,
    },
    "$store.state.formData.frontendEvents": {
      handler(val) {
        console.log(val);
        const data = this.extractFunctions(val);
        console.log(eval(data.OnLoad.body));
      },
      deep: true,
    },
    relevanceList(val) {
      console.log(val, "relevanceList");
    },
  },
  data() {
    return {
      isFull: false,
      isCollapse: false, //侧边栏显示与隐藏
      total: 0, //表单列表总数
      pageSize: 10, //表单列表分页
      pageNumber: 1, //表单列表分页
      tableLoading: false, //表单列表加载
      relevanceDetails: {
        data: {},
        field: [],
        search: [],
      },
      form: {},
      searchParamsJson: {},
      flowLogList: [],
      operateLogList: [],
      commentList: [],
      logList: [],
      activeName: "flowLog",
      open: false,
      tableFormData: {},
      status: null,
      taskApproveDialog: false,
      showPrintPage: false,
      statusName: {
        Effective: "已完成",
        Running: "进行中",
        Canceled: "已取消",
        Draft: "草稿",
      },
      statusColor: {
        Effective: "#2e98fe",
        Running: "#EDAF31",
        Canceled: "#171A1D",
        Draft: "#171A1D",
      },
      sidebarIcon: [
        {
          name: "流程日志",
          id: "flowLog",
          icon: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/24/流程日志@2x-181749990.png",
        },
        {
          name: "评论",
          id: "comment",
          icon: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/24/评论@2x-181749993.png",
        },
        {
          name: "操作日志",
          id: "operateLog",
          icon: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/24/操作日志@2x-181750000.png",
        },
      ],
    };
  },
  methods: {
    extractFunctions(code) {
      try {
        // 直接使用全局的 acorn
        const ast = acorn.parse(code, {
          ecmaVersion: 2020,
          sourceType: "script",
        });

        const functions = {};

        const traverse = (node) => {
          if (node.type === "FunctionDeclaration") {
            functions[node.id?.name] = {
              type: "function",
              name: node.id?.name,
              start: node.start,
              end: node.end,
              body: code.slice(node.body.start, node.body.end),
            };
          } else if (
            node.type === "VariableDeclarator" &&
            node.init?.type === "FunctionExpression"
          ) {
            functions[node.id.name] = {
              type: "method",
              name: node.id.name,
              start: node.init.start,
              end: node.init.end,
              body: code.slice(node.init.body.start, node.init.body.end),
            };
          } else if (
            node.type === "Property" &&
            node.value?.type === "FunctionExpression"
          ) {
            const functionName = node.key.name || node.key.value;
            functions[functionName] = {
              type: "method",
              name: functionName,
              start: node.value.start,
              end: node.value.end,
              body: code.slice(node.value.body.start, node.value.body.end),
            };
          }

          // 递归遍历子节点
          for (const key in node) {
            if (node[key] && typeof node[key] === "object") {
              traverse(node[key]);
            }
          }
        };

        traverse(ast);
        return functions;
      } catch (error) {
        console.error("解析错误:", error);
        return {};
      }
    },
    // 详情接口
    async handleFormVal(data) {
      this.formLoading = true;
      await this.$store.dispatch("formData/getDetailData", data);
    },

    // 设置打印
    async handlePrint() {
      this.logList = [];
      let res = await getProcessDetail(this.fieldData.ProcessId);
      res.data.reverse().forEach((item) => {
        if (item.taskList.length > 0) {
          item.taskList.reverse().forEach((el) => {
            if (el.nodeType !== "CC") {
              this.logList.push(...item.taskList);
            }
          });
        }
      });
      this.showPrintPage = true;
    },
    // 设置表单复制
    async handleCopy() {
      let obj = {
        formName: this.viewPage.formName + "-复制新增",
        formId: this.fieldData.formId,
        type: "copy",
      };
      this.$store.commit("formData/setPageNameList", {
        val: obj,
        type: "copy",
      });
      await this.handleFormVal(obj);
    },
    // 详情关联表单数据新增
    async handleTableAdd() {
      let obj = {
        formName: this.activeTabItems.formName + "-新增",
        relevance: {
          id: this.fieldData.id,
          Name: this.fieldData.Name,
        },
        formId: this.activeTabItems.id,
        type: "add",
      };
      this.$store.commit("formData/setPageNameList", { val: obj, type: "add" });
      this.handleFormVal(obj);
    },
    // 路由栈点击
    async handleBreadcrumb(item, index) {
      if (
        item.formId === this.$route.query.code &&
        item.formName === this.viewPage.formName
      )
        return;
      this.$store.commit("formData/setPageNameList", {
        type: "splice",
        val: index,
      });
      this.handleFormVal({
        ...this.viewPage,
        type: "see",
      });
    },
    // 流程按钮
    // 删除
    handleDel() {
      this.$confirm("此操作将永久删除该表单, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          await pageListDel(this.$route.query.code, [this.$route.query.objId]);
          this.$message.success("删除成功");
          this.handleClose("refresh");
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    // 编辑
    handleEdit() {
      this.type = "edit";
    },
    // 保存
    confirmInfo(str) {
      if (this.$store.state.formData.upLoading) {
        return this.$message.info("正在上传中，请稍后操作");
      }
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          if (this.formLoading) return;
          this.formLoading = true;
          let res;
          if (this.type === "add" || this.type === "copy") {
            res = await pageListAdd(
              {
                ...this.formData,
              },
              this.$route.query.code,
              this.type
            );
          } else {
            res = await pageListAdd(
              {
                ...this.formData,
                Id: this.$route.query.objId,
              },
              this.fieldData.formId,
              str === "Approve" ? this.status : "update"
            );
            if (str === "Approve") {
              console.log(this.form);
              let deliverId = this.form.deliverId
                ? this.form.deliverId[0]?.id
                : null;
              if (this.status == 2 && !this.form.comment)
                return this.$message.info("请输入拒绝原因");
              if (this.status == 3 && !deliverId)
                return this.$message.info("请选择转交人");

              await taskApprove({
                comment: this.form.comment,
                deliverId,
                instanceId: this.fieldData.ProcessId,
                status: this.status,
              });
              this.taskApproveDialog = false;
            }
          }
          if (res.code === 500) {
            this.formLoading = false;
            this.$message.info(res.message);
            return;
          }
          this.$message.success(this.type === "add" ? "新增成功" : "编辑成功");
          this.formLoading = false;
          this.handleClose("refresh");
        } else {
          return false;
        }
      });
    },
    // 关联表单搜索条件
    tableQueryList() {
      this.searchParamsJson = {
        ...this.searchParamsJson,
        ...this.tableFormData,
      };
      this.getTableList(this.activeTabItems.id, "stop");
    },
    // 关联表单点击
    async handleTab(item) {
      // console.log(item, "item");
      if (item.id === this.activeTabItems.id) return;
      this.open = false;
      this.activeTabItems = item;
      if (item.formName === "详情") {
        this.handleFormVal({
          ...this.viewPage,
          type: "see",
        });
      } else {
        this.tableLoading = true;
        if (item.mappingItem) {
          this.searchParamsJson = {};
          this.$set(this.searchParamsJson, item.mappingItem, [
            { Id: this.fieldData.id },
          ]);
        }
        this.getTableList(this.activeTabItems.id);
      }
    },
    // 获取子表数据
    async getTableList(id, str) {
      let res = await getPageViewList({
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        formId: id,
        searchParamsJson: this.searchParamsJson,
      });
      this.$set(this.relevanceDetails, "data", res.data.data);
      this.$set(this.relevanceDetails, "field", res.data.field);
      if (!str) {
        this.$set(this.relevanceDetails, "search", res.data?.search);
        this.relevanceDetails.search = this.relevanceDetails.search.filter(
          (item) => item.code !== this.activeTabItems.mappingItem
        );
        this.relevanceDetails.search.forEach((item) => {
          this.$set(this.tableFormData, item.code, null);
        });
      }
      this.total = res.data.data.total;
      this.tableLoading = false;
    },
    // 子表点击数据标题
    async handleName(row) {
      console.log(row);
      let obj = {
        formName: this.activeTabItems.formName,
        id: row.id,
        formId: this.activeTabItems.id,
      };
      let index = this.pageNameList.findIndex(
        (item) => item.formId === obj.formId
      );
      obj.index = index;
      // 判断是否有路由栈 有则替换
      this.$store.commit("formData/setPageNameList", {
        val: obj,
        type: index !== -1 ? "replace" : "add",
      });
      this.handleFormVal({
        ...this.viewPage,
        type: "see",
      });
    },
    // 每行样式
    headerCellStyle,
    //自适应宽度
    flexColumnWidth,
    cellStyle,

    // 子表分页
    handleSizeChange(val) {
      this.tableLoading = true;
      this.pageSize = val;
      this.getTableList(this.activeTabItems.id, "stop");
    },
    // 子表分页
    handleCurrentChange(val) {
      this.tableLoading = true;
      this.pageNumber = val;
      this.getTableList(this.activeTabItems.id, "stop");
    },
    // 流程催办
    handleUrge(text) {
      urgeFlow({
        dataId: this.fieldData.id,
        formId: this.fieldData.formId,
        remark: text,
      });
    },
    // 侧边日志
    handleOpen() {
      this.open = !this.open;
      if (this.open && this.activeName === "flowLog") {
        this.getFlowLogList();
      }
      if (this.open && this.activeName === "operateLog") {
        this.getOperateLog();
      }
      if (this.open && this.activeName === "comment") {
        this.getCommentListFn();
      }
    },
    // 侧边日志
    handleOriginal(str) {
      this.activeName = str;
      this.handleOpen();
    },
    // 侧边日志
    handleClick(tab) {
      if (tab.name === "flowLog") {
        this.getFlowLogList();
      } else if (tab.name === "operateLog") {
        this.getOperateLog();
      } else {
        this.getCommentListFn();
      }
    },
    // 获取流程日志
    async getFlowLogList() {
      let res = await getProcessDetail(this.fieldData.ProcessId);
      this.flowLogList = res.data.reverse();
      this.flowLogList.forEach((item) => {
        if (item.taskList.length > 1) {
          item.taskList = item.taskList.reverse();
        }
      });
    },
    // 获取操作日志
    async getOperateLog() {
      let res = await getoperateLogDetail(
        this.fieldData.id,
        this.fieldData.formId
      );
      this.operateLogList = res.data;
    },
    // 获取评论日志
    getCommentListFn() {
      getCommentList({
        dataId: this.fieldData.id,
        formId: this.fieldData.formId,
        pageNumber: 1,
        pageSize: 100,
      }).then((res) => {
        this.commentList = res.data.records || [];
      });
    },
    // 关闭弹窗
    async handleClose(str) {
      // 详情页面 从钉钉跳转到这里 关闭直接关闭网页
      if (this.$route.path === "/detail") {
        window.close();
        return;
      }
      // 关闭侧边栏
      this.open = false;
      //如果缓存页面有多个关闭最后一个页面 不需要关闭弹窗
      if (this.pageNameList.length > 1) {
        this.$store.commit("formData/setPageNameList", {
          val: this.pageNameList.length - 2,
          type: "splice",
        });
        this.handleFormVal({
          ...this.viewPage,
          type: "see",
        });
      } else {
        if (str === "refresh") this.$store.commit("formData/setRefresh", true);
        else {
          this.$router.push(
            {
              query: {
                code: this.$store.state.formData.tableData.id,
              },
            },
            () => { }
          );
        }
        this.isVisibility = false;
      }
    },
    queryList() {
      console.log(this.formData, "111");
    },
  },
};
</script>

<style scoped lang="less" src='./index.less'></style>